var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2d2d2d",
    d: "M7.783 7.01 14.22.575l.707.707L8.49 7.717zM.075 1.283.782.576 7.217 7.01l-.707.707z"
  })));
};
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTUgOSI+PHRpdGxlPmNoZXZyb248L3RpdGxlPjxyZWN0IHg9IjYuODA0IiB5PSIzLjY0NiIgd2lkdGg9IjkuMTAxIiBoZWlnaHQ9IjEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMzk0IDkuMjQzKSByb3RhdGUoLTQ1KSIgZmlsbD0iIzJkMmQyZCIvPjxyZWN0IHg9IjMuMTQ2IiB5PSItMC40MDQiIHdpZHRoPSIxIiBoZWlnaHQ9IjkuMTAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS44NjQgMy43OTMpIHJvdGF0ZSgtNDUpIiBmaWxsPSIjMmQyZDJkIi8+PC9zdmc+";